import React from "react";
import { useTranslation } from 'react-i18next'; // Import useTranslation
import CloseIconNew from "../icons/CloseIconNew";
import style from "./AccessDeniedModal.module.scss";

const AccessDeniedModal = ({ onClose }) => {
  const { t } = useTranslation(); // Instantiate the hook
  return (
    <div className={style.overlay}>
      <div className={style.modal}>
        <div className={style.header}>
          <h2 className={style.title}>{t('accessDeniedModal.title')}</h2>
          <button onClick={onClose} className={style.closeButton}>
            <CloseIconNew />
          </button>
        </div>

        <div className={style.content}>
          <p className={style.description}>
            {t('accessDeniedModal.description')}
          </p>

          <div className={style.supportSection}>
            <h3 className={style.supportTitle}>{t('accessDeniedModal.supportTitle')}</h3>
            <div className={style.supportContact}>
              <span className={style.phoneNumber}>+7 (775) 007-53-97</span>
              <a
                href="https://wa.me/77750075397"
                target="_blank"
                rel="noopener noreferrer"
                className={style.whatsappButton}
              >
                WhatsApp
              </a>
            </div>
          </div>
        </div>

        <div className={style.footer}>
          <button onClick={onClose} className={style.closeModalButton}>
            {t('accessDeniedModal.closeButton')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccessDeniedModal;
